var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5H14.5C15.1294 2.5 15.7219 2.79638 16.0996 3.2998L17.5996 5.2998C17.8593 5.646 18 6.06726 18 6.5V16.5C18 17.6046 17.1046 18.5 16 18.5H4C2.89543 18.5 2 17.6046 2 16.5V6.5C2 6.06726 2.14075 5.646 2.40039 5.2998L3.90039 3.2998C4.27811 2.79638 4.87062 2.5 5.5 2.5Z",
    stroke: "#919191",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5V15.5M10 15.5L7.5 13M10 15.5L12.5 13",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgArchive;